module.exports = __webpack_public_path__ + "img/Weapon_261.cc177ded.png";